var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import styled from 'styled-components';
export function DropContainer(_a) {
    var children = _a.children, closeDropDown = _a.closeDropDown, width = _a.width, offset = _a.offset, verticalOffset = _a.verticalOffset;
    var ref = useRef(null);
    var handleClick = function (event) {
        var el = event.target;
        var refEl = ref.current;
        do {
            // if clicked on menu don't close
            if (el === refEl) {
                return;
            }
        } while ((el = el.parentElement));
        closeDropDown();
    };
    useEffect(function () {
        window.addEventListener('click', handleClick);
        return function () { return window.removeEventListener('click', handleClick); };
    }, []);
    return (_jsx("div", __assign({ ref: ref }, { children: _jsx(Container, __assign({ offset: offset, dropDownWidth: width, verticalOffset: verticalOffset }, { children: children }), void 0) }), void 0));
}
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: 4px;\n  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),\n    0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 8px 10px 1px rgba(0, 0, 0, 0.14);\n  background-color: #ffffff;\n  position: absolute;\n  transform: translate(0, 100%);\n  bottom: ", ";\n  z-index: 1001;\n  right: ", ";\n  width: ", ";\n"], ["\n  border-radius: 4px;\n  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),\n    0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 8px 10px 1px rgba(0, 0, 0, 0.14);\n  background-color: #ffffff;\n  position: absolute;\n  transform: translate(0, 100%);\n  bottom: ", ";\n  z-index: 1001;\n  right: ", ";\n  width: ", ";\n"])), function (_a) {
    var verticalOffset = _a.verticalOffset;
    return (verticalOffset ? verticalOffset : '-8px');
}, function (_a) {
    var offset = _a.offset;
    return (offset ? offset : 0);
}, function (_a) {
    var dropDownWidth = _a.dropDownWidth;
    return (dropDownWidth ? dropDownWidth : 'auto');
});
var templateObject_1;
